module.exports = __webpack_public_path__ + "static/media/over-150.52526cd5.svg";